import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import FrameworkUtils from 'utils/framework';
import WelcomeMatModalEN from 'components/GlobalModals/WelcomeMatModal/locales/WelcomeMatModal_en_US';
import WelcomeMatModalFR from 'components/GlobalModals/WelcomeMatModal/locales/WelcomeMatModal_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(WelcomeMatModalEN, WelcomeMatModalFR);

const fields = createSelector(
    createStructuredSelector({
        accessMessage1: getTextFromResource(getText, 'accessMessage1'),
        accessMessage2: getTextFromResource(getText, 'accessMessage2'),
        doesNotShip: getTextFromResource(getText, 'doesNotShip'),
        internationalSites: getTextFromResource(getText, 'internationalSites'),
        continueTo: getTextFromResource(getText, 'continue')
    }),
    localization => {
        return {
            localization
        };
    }
);

const functions = null;

const withWelcomeMatModalProps = wrapHOC(connect(fields, functions));

export {
    withWelcomeMatModalProps, fields, functions
};
